const moment = require("moment-timezone");

module.exports = function (date, timezone) {
  var dateFormattedWithoutTimezone = date.format("YYYY-MM-DDTHH:mm:ss");
  return moment.tz(dateFormattedWithoutTimezone, timezone);
};
